import { patchAdminFeatureFlagByIdSlice } from './patch';

export const { requestPatchAdminFeatureFlagById, resetPatchAdminFeatureFlagById } =
    patchAdminFeatureFlagByIdSlice.asyncActionCreators;

export * from './customer/actions';
